import React, { useEffect, useState } from 'react';
import { fetchData } from '../../../nextgen/service/dataServices';
import { Card, Space, Table, Tag, Tooltip } from 'antd';
import { pageSizeOptions } from '../../../nextgen/components/common-constants';
import { InfoCircleOutlined } from '@ant-design/icons';

function ActivityPage({ from = null, to = null }) {
  const [data, setData] = useState([]);
  const [filters, setFilters] = useState({
    page: 0,
    size: 10,
    from: from,
    to: to
  });

  useEffect(() => {
    setFilters(prevState => {
      return {
        ...prevState,
        from: from,
        to: to
      }
    })

  }, [from, to])

  const response = fetchData('/api/data-changes', data => setData(data.content), filters);

  function getActionColor(action) {
    switch (action) {
      case 'CREATE':
        return '#28cc40';
      case 'UPDATE':
        return '#A85BDF';
      case 'DELETE':
        return '#f32e18';
      default:
        return '';
    }
  }

  const columns = [
    {
      title: 'User',
      dataIndex: 'user',
      key: 'user',
    },
    {
      title: 'Timestamp',
      dataIndex: 'timestamp',
      key: 'timestamp',
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      render: (text, record) => (
        <>
          <Tag
            style={{
              color: getActionColor(record.action),
              borderColor: getActionColor(record.action),
            }}
          >
            {text.toUpperCase()}
          </Tag>
        </>
      ),
    },
    {
      title: 'Entity Type',
      dataIndex: 'entityType',
      key: 'entityType',
    },
    {
      title: 'Entity Id',
      dataIndex: 'entityId',
      key: 'entityId',
    },

  ];

  const handleTableChange = pagination => {
    if (pagination.current - 1 !== filters.page) {
      setFilters(prevState => ({
        ...prevState,
        page: pagination.current - 1,
      }));
    }
    if (pagination.pageSize !== filters.size) {
      setFilters(prevState => ({
        ...prevState,
        size: pagination.pageSize,
      }));
    }
  };

  return (
    <Table
      dataSource={data}
      columns={columns}
      loading={response.isFetching}
      rowKey={record => record.timestamp}
      onChange={handleTableChange}
      expandable={{
        expandedRowRender: record => <Card bordered={false}>
          <p>{record.prettyPrint.split("\n").map(t => (<p>{t}<br/></p>))}</p>
        </Card>,
      }}
      pagination={{
        pageSize: filters.size,
        total: response.data ? response.data.data.totalElements : 0,
        showSizeChanger: true,
        current: filters.page + 1,
        pageSizeOptions: pageSizeOptions,
        showTotal: (total, range) => {
          return `${range[0]}-${range[1]} of ${total} items`;
        },
      }}
    />
  );
}

export default ActivityPage;
